import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import Strings from "../../Constants/Strings";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify} from "../../Utils/Notify";
import {handleUserAccess} from "../../Utils/Auth";
import MFAChallenge from "../Auth/MFAChallenge";
import AuthLayout, {AuthCard, AuthHeading} from "../Layout/AuthLayout";
import {Button, FormField, TextInput} from "../UI";

const Login = props => {

    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [mfaToken, setMfaToken] = useState('');

    useEffect(() => {
        document.title = "Log in | " + Strings.APP_DESCRIPTION;
        if (globalState.userLoggedIn) {
            window.location.assign(process.env.PUBLIC_URL + "/dashboard");
        }
    }, [globalState.userLoggedIn]);

    const logIn = (e) => {
        e.preventDefault();
        let data = new FormData();
        data.append("email", email)
        data.append("password", password)

        setIsLoading(true);

        postData(Endpoints.LOGIN, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.mfa_required) {
                    setMfaToken(res.mfa_token);
                } else if (res.success === 1) {
                    handleUserAccess(res, globalActions, true);
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });

    }


    if (mfaToken) {
        return <MFAChallenge mfaToken={mfaToken} onCancel={() => setMfaToken('')} />;
    }

    return (
        <AuthLayout>
            <AuthCard>
                <AuthHeading>
                    <h2>Sign in</h2>
                    <p>Welcome back. Manage all Pick&apos;n&apos;Drop services from here.</p>
                </AuthHeading>

                <form id="loginForm" onSubmit={logIn}>
                    <FormField label="Email address" htmlFor="loginEmail">
                        <TextInput
                            type="text"
                            id="loginEmail"
                            required
                            autoFocus
                            $size="lg"
                            placeholder="you@pickndrop.com"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Password" htmlFor="loginPassword">
                        <TextInput
                            type="password"
                            id="loginPassword"
                            required
                            $size="lg"
                            placeholder="••••••••"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                        />
                    </FormField>

                    <Button
                        type="submit"
                        size="lg"
                        fullWidth
                        loading={isLoading}
                        style={{marginTop: 8}}
                    >
                        {isLoading ? "Signing in…" : "Sign in"}
                    </Button>
                </form>
            </AuthCard>
        </AuthLayout>
    )
};

export default Login;
